export default __webpack_public_path__ + "abddfc6a0ef546be3b41d0ce439414e4.svg";